import { useState } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import Nav from './nav';
import Main from './main';
import Header from './header';
import { useStoreDataRefresh } from '../../hooks/useStoreDataRefresh';
import StoreChangeIndicator from '../../components/StoreChangeIndicator';

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const [openNav, setOpenNav] = useState(false);

  // Automatically refresh data when store changes
  useStoreDataRefresh('all');

  return (
    <>
      <Header onOpenNav={() => setOpenNav(true)} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
        }}
      >
        <Nav openNav={openNav} onCloseNav={() => setOpenNav(false)} />

        <Main>{children}</Main>
      </Box>

      {/* Show loading indicator when switching stores */}
      <StoreChangeIndicator />
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
